import { useEffect } from 'react';

const PageTitle = ({ label }) => {
  useEffect(() => {
    document.title = [label, 'Indiana Adoption Program'].filter((s) => s).join(' - ');
  }, [label]);
  return null;
};

export default PageTitle;
